<h2 mat-dialog-title cdkFocusInitial>{{ "common.session.timeoutWarning.title" | translate }}</h2>

<mat-dialog-content>
  <p>{{ "common.session.timeoutWarning.message" | translate }}</p>
  <p aria-hidden="true">
    {{ "common.session.timeoutWarning.countdown" | translate: { countdown: formattedCountdown() } }}
  </p>
  <span class="cdk-visually-hidden" aria-live="polite" aria-atomic="true">
    @if (announcement()) {
      {{ "common.session.timeoutWarning.countdown" | translate: { countdown: announcement() } }}
    }
  </span>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button matButton="filled" (click)="onStaySignedIn()">
    {{ "common.session.timeoutWarning.staySignedInButton" | translate }}
  </button>
  <button matButton="outlined" (click)="onSignOut()">
    {{ "common.session.timeoutWarning.signOutButton" | translate }}
  </button>
</mat-dialog-actions>
